import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n          View Offers Generated\n        ")
], -1);
const _hoisted_4 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_5 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("thead", { class: "bg-gray-50" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        }, "Name"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        }, "Current Assignee"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "Status")
    ])
], -1);
const _hoisted_7 = {
    key: 0,
    class: "bg-white"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "whitespace-nowrap py-3.5 pl-4 pr-3 sm:pl-6 text-sm text-gray-500" };
const _hoisted_10 = { class: "whitespace-nowrap px-3 py-3.5 text-sm text-gray-500" };
const _hoisted_11 = {
    key: 1,
    class: "text-gray-400 text-center p-8"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("table", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(),
                    (_ctx.offers.length)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offers, (offer) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: offer.docId
                                }, [
                                    _createElementVNode("td", {
                                        class: "whitespace-nowrap py-3.5 pl-4 pr-3 sm:pl-6 text-sm text-gray-500 text-blue-600 hover:underline cursor-pointer",
                                        onClick: ($event) => (_ctx.navigateToDocument(offer.docId, offer.requestedBy, offer.currentStageName))
                                    }, _toDisplayString(offer.candidateName), 9, _hoisted_8),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_9, _toDisplayString(offer.currentAssigneeEmail), 1),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_10, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["inline-flex rounded-full px-2 text-xs font-semibold leading-5", {
                                                    'bg-green-100 text-green-800': offer.status.toLowerCase() === 'submitted' || offer.status.toLowerCase() === 'completed',
                                                    'bg-yellow-100 text-yellow-800': offer.status.toLowerCase() === 'draft',
                                                    'bg-red-100 text-red-800': offer.status.toLowerCase() === 'rejected'
                                                }])
                                        }, _toDisplayString(offer.status), 3)
                                    ])
                                ]));
                            }), 128))
                        ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_11, "No offers to show..."))
                ])
            ])
        ])
    ]));
}
